// src/components/Common/UIIcon.jsx
import React from "react";
import { ReactSVG } from "react-svg";

// profile / popup icons
import phone from "../../assets/svg/phone.svg";
import email from "../../assets/svg/email.svg";
import student from "../../assets/svg/student.svg";
import download from "../../assets/svg/download.svg";
import success from "../../assets/svg/success.svg";
import cancel from "../../assets/svg/cancel.svg";
import clock from "../../assets/svg/clock.svg";

// ui/action icons
import edit from "../../assets/svg/edit.svg";
import trash from "../../assets/svg/trash.svg";
import search from "../../assets/svg/search.svg";
import add from "../../assets/svg/add-s.svg";
import eye from "../../assets/svg/eye.svg";
import key from "../../assets/svg/key.svg";
import arrow from "../../assets/svg/arrow-s.svg";

import check from "../../assets/svg/material-symbols--check-rounded.svg";
import close from "../../assets/svg/material-symbols--close-rounded.svg";
import favorite from "../../assets/svg/material-symbols--star-outline-rounded.svg";
import important from "../../assets/svg/zondicons--exclamation-outline.svg";
import copy from "../../assets/svg/copy.svg";
import arrowLong from "../../assets/svg/arrow.svg";

import graduate from "../../assets/svg/graduate.svg";
import manager from "../../assets/svg/mdi--account-cog-outline.svg";
import group from "../../assets/svg/material-symbols--group-outline.svg";
import map from "../../assets/svg/map.svg";

export const ICONS = {
   // profile
   phone,
   email,
   student,
   download,

   // status
   success,
   cancel,
   clock,

   // ui/actions
   edit,
   trash,
   search,
   add,
   eye,
   key,
   arrow,

   // toggles / common
   check,
   close,

   // popup flags / misc
   favorite,
   important,
   copy,
   arrowLong,

   // people / roles / places
   graduate,
   manager,
   group,
   map,

   // nume vechi folosit de IconButton (coșul de gunoi apărea gol)
   delete: trash,
};

const HOT_ICON_NAMES = [
   "add",
   "arrow",
   "arrowLong",
   "check",
   "close",
   "clock",
   "copy",
   "edit",
   "favorite",
   "important",
   "search",
   "success",
   "cancel",
   "key",
   "eye",
];

const preloadedIconSrc = new Set();

function preloadIconSource(src) {
   if (!src || preloadedIconSrc.has(src) || typeof window === "undefined")
      return;

   preloadedIconSrc.add(src);

   if (typeof fetch === "function") {
      fetch(src, { credentials: "same-origin", cache: "force-cache" }).catch(
         () => {},
      );
      return;
   }

   const img = new Image();
   img.src = src;
}

export function preloadUIIcons(iconNames = HOT_ICON_NAMES) {
   for (const name of iconNames) {
      preloadIconSource(ICONS[name]);
   }
}

export default function UIIcon({ name, className = "", title, ...rest }) {
   const src = ICONS[name];
   if (!src) return null;

   return (
      <ReactSVG
         useRequestCache
         src={src}
         className={`uiIcon ${className}`.trim()}
         title={title}
         {...rest}
      />
   );
}
